import { render, staticRenderFns } from "./MenuToolbar.vue?vue&type=template&id=53dfd198&scoped=true&"
import script from "./MenuToolbar.vue?vue&type=script&lang=js&"
export * from "./MenuToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dfd198",
  null
  
)

export default component.exports